import type { Translations } from '../../types'

const authMessages: Translations = {
  "auth.eyebrow": "Admin frontend",
  "auth.title": "Accedi al back office",
  "auth.loginEyebrow": "Login admin",
  "auth.loginTitle": "Controllo catalogo, slider e richieste assistenza",
  "auth.loginDescription": "Usa le credenziali create durante il setup iniziale per accedere al pannello di amministrazione.",
  "auth.username": "Username o email",
  "auth.usernamePlaceholder": "Inserisci username o email",
  "auth.password": "Password",
  "auth.otp": "Codice 2FA / Recovery",
  "auth.otpMethodsTitle": "Metodi accettati",
  "auth.otpMethodOtpTitle": "Authenticator OTP",
  "auth.otpMethodOtpHint": "Usa il codice a 6 cifre della tua app Authenticator.",
  "auth.otpMethodRecoveryTitle": "Recovery code",
  "auth.otpMethodRecoveryHint": "In alternativa usa un recovery code (es. ABCDE-12345).",
  "auth.otpPlaceholder": "es. 123456 oppure ABCDE-12345",
  "auth.otpHint": "Inserisci un codice Authenticator o un recovery code.",
  "auth.passkey.loginButton": "Accedi con passkey",
  "auth.passkey.error.title": "Errore passkey",
  "auth.passkey.error.generic": "Impossibile completare l'accesso con passkey.",
  "auth.passkey.error.session": "Sessione di verifica non valida. Riparti da username e password.",
  "auth.passkey.error.notSupported": "Questo dispositivo non supporta l'accesso con passkey.",
  "auth.passkey.error.start": "Impossibile avviare la verifica con passkey.",
  "auth.passkey.error.verify": "Verifica passkey non riuscita.",
  "auth.passkey.orSeparator": "oppure",
  "auth.passkey.loginHint": "Usa impronta digitale, Face ID o dispositivo sicuro",
  "auth.turnstileLabel": "Verifica di sicurezza",
  "auth.turnstileLoading": "Caricamento verifica di sicurezza...",
  "auth.backToCredentials": "Torna a username e password",
  "auth.loginSubtitle": "Inserisci le tue credenziali per continuare.",
  "auth.loginSecurityHint": "Se hai attivato la verifica in due passaggi, ti verrà richiesto il codice al passaggio successivo.",
  "auth.otpTitle": "Verifica in due passaggi",
  "auth.otpSubtitle": "Inserisci il codice per completare l'accesso.",
  "auth.forgotPassword": "Hai dimenticato la password?",
  "auth.forgotPassword.heroTitle": "Recupero accesso backoffice",
  "auth.forgotPassword.heroSubtitle": "Ripristina l'accesso in modo sicuro senza interrompere il flusso operativo.",
  "auth.forgotPassword.title": "Recupera la tua password",
  "auth.forgotPassword.subtitle": "Inserisci email o username dell'account admin. Se l'account esiste, riceverai un link di recupero.",
  "auth.forgotPassword.identifierLabel": "Email o username",
  "auth.forgotPassword.identifierPlaceholder": "es. owner@emporion.local",
  "auth.forgotPassword.submit": "Invia link reset",
  "auth.forgotPassword.submitting": "Invio in corso...",
  "auth.forgotPassword.backToLogin": "Torna al login",
  "auth.forgotPassword.successTitle": "Controlla la tua casella email",
  "auth.forgotPassword.successSubtitle": "Il link scade rapidamente per proteggere l'account.",
  "auth.forgotPassword.successMessage": "Se l'account esiste, abbiamo inviato un link di recupero.",
  "auth.forgotPasswordTitle": "Recupero password",
  "auth.forgotPasswordMessage": "Contatta un amministratore per il reset della password.",
  "auth.forgotPassword.error": "Non siamo riusciti a inviare il link di recupero. Riprova tra poco.",
  "auth.resetPassword.heroTitle": "Aggiorna credenziali in sicurezza",
  "auth.resetPassword.heroSubtitle": "Completa il reset con un link monouso e una password robusta.",
  "auth.resetPassword.title": "Reimposta password admin",
  "auth.resetPassword.subtitle": "Scegli una password sicura per proteggere il tuo account.",
  "auth.resetPassword.invalidTitle": "Link non valido",
  "auth.resetPassword.invalid": "Il link non è valido. Richiedi un nuovo link dalla pagina di accesso.",
  "auth.resetPassword.expiredTitle": "Link scaduto",
  "auth.resetPassword.expired": "Il link è scaduto. Richiedi un nuovo link dalla pagina di accesso.",
  "auth.resetPassword.usedTitle": "Link già utilizzato",
  "auth.resetPassword.used": "Questo link è già stato usato. Richiedi un nuovo link dalla pagina di accesso.",
  "auth.resetPassword.successTitle": "Password aggiornata",
  "auth.resetPassword.success": "Password aggiornata con successo. Ora puoi accedere con le nuove credenziali.",
  "auth.resetPassword.backToLogin": "Torna al login",
  "auth.resetPassword.newPassword": "Nuova password",
  "auth.resetPassword.confirmPassword": "Conferma password",
  "auth.resetPassword.showPassword": "Mostra password",
  "auth.resetPassword.hidePassword": "Nascondi password",
  "auth.resetPassword.showConfirmPassword": "Mostra conferma password",
  "auth.resetPassword.hideConfirmPassword": "Nascondi conferma password",
  "auth.resetPassword.showShort": "Mostra",
  "auth.resetPassword.hideShort": "Nascondi",
  "auth.resetPassword.submit": "Aggiorna password",
  "auth.resetPassword.submitting": "Aggiornamento...",
  "auth.resetPassword.error.submit": "Impossibile aggiornare la password.",
  "auth.resetPassword.error.passwordWeak": "La password non soddisfa i requisiti minimi.",
  "auth.resetPassword.error.passwordMismatch": "Le password non coincidono.",
  "auth.resetPassword.strength.label": "Sicurezza password",
  "auth.resetPassword.strength.weak": "Debole",
  "auth.resetPassword.strength.medium": "Media",
  "auth.resetPassword.strength.strong": "Forte",
  "auth.resetPassword.requirements.length": "Almeno 8 caratteri",
  "auth.resetPassword.requirements.uppercase": "Almeno una maiuscola",
  "auth.resetPassword.requirements.lowercase": "Almeno una minuscola",
  "auth.resetPassword.requirements.number": "Almeno un numero",
  "auth.resetPassword.requirements.special": "Almeno un simbolo",
  "auth.resetPassword.requirements.mixedCase": "Maiuscole e minuscole combinate",
  "auth.submitLoading": "Accesso in corso...",
  "auth.submitOtp": "Verifica codice",
  "auth.submitCredentials": "Accedi",
  "auth.submit": "Accedi",
  "auth.capabilities.title": "Cosa puoi fare",
  "auth.capabilities.slider": "Gestire lo slider hero (crea, modifica, riordina).",
  "auth.capabilities.supportRequests": "Vedere e gestire le richieste assistenza clienti.",
  "auth.capabilities.menu": "Aggiungere voci di menu/pagine CMS.",
  "auth.capabilities.builder": "Comporre le pagine con il Compositore contenuti.",
  "auth.api.title": "API",
  "auth.api.gateway": "Gateway: /api",
  "auth.api.auth": "Auth → /api/auth/login",
  "auth.api.cms": "CMS → /api/settings/hero, /api/pages",
  "auth.api.supportRequests": "Support → /api/support/requests",
  "auth.logout": "Logout",
  "auth.logoutSubtitle": "Termina sessione",
  "auth.loginSuccess": "Login ok. Salvataggi via API attivi.",
  "auth.loginMessage": "Benvenuto nel pannello amministrativo.",
  "auth.loginError": "Errore di accesso",
  "auth.logoutSuccess": "Logout eseguito.",
  "auth.logoutMessage": "A presto.",
  "auth.logoutConfirm": "Conferma logout",
  "auth.logoutConfirmMessage": "Sei sicuro di voler uscire?",
  "auth.error.setupIncomplete": "Setup iniziale non completato. Completa il wizard prima di accedere.",
  "auth.error.invalid": "Credenziali non valide",
  "auth.error.generic": "Errore di login. Controlla auth-service/gateway."
}

export default authMessages
